var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('main',{staticClass:"mt-5 pt-5"},[(_vm.isUserLogged)?_c('mdb-container',{attrs:{"fluid":""}},[_c('router-view')],1):_c('LoginPage'),_c('vue-snotify')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }